

















import { Component, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import { Getter } from 'vuex-class';

    @Component({
      components: {
      },
    })
export default class extends Vue {
        @Getter public navData: any;

        @Getter public title: any;

        @Getter public userImg: any;

        // init nav active
        private defaultNavActive: any = 0;

        private navigation(item: any, index: any) {
          this.defaultNavActive = index;
          this.$router.push({ name: item.name });
        }

        private created() {
          const array: any = [];
          _.map(this.navData, (item: any) => {
            array.push(item.name);
          });
          this.defaultNavActive = _.indexOf(array, this.$route.name);
          if (this.$route.name == 'personal') {
            this.defaultNavActive = '#';
          }
        }
}
